document.getElementById('learn-more').onclick = function()
{
    window.scrollTo(0, window.innerHeight);
}


// WEBPACK FOOTER //
// ./scripts/custom/learn_more.js